import{a as f}from"./ids-chunk-BN53CJKP.js";import{a as x}from"./ids-chunk-2OQEBFK3.js";import{a as b}from"./ids-chunk-U4K5B3VN.js";import{a as u}from"./ids-chunk-6QMEC4B7.js";import{a as h,b as c}from"./ids-chunk-XE4WFW5M.js";import{a as p}from"./ids-chunk-W3LDHTW6.js";import{e as s}from"./ids-chunk-Y6KVKFJX.js";import{a as t}from"./ids-chunk-TFRXZ5TN.js";import{a as d,b as n,d as l,f as a}from"./ids-chunk-ZMMCFAAI.js";var v=`/* Ids Hyperlink Component */
.ids-hyperlink {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 1px solid transparent;
  border-radius: var(--ids-hyperlink-border-radius);
  cursor: var(--ids-hyperlink-cursor);
  display: inline-block;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-hyperlink-font-size);
  font-weight: var(--ids-hyperlink-font-weight);
  padding: var(--ids-space-3xs) var(--ids-space-2xs);
  position: relative;
  margin-block-start: -3px;
  margin-inline-start: -4px;
  /* Ids Typography System */
}
.ids-hyperlink.disabled, .ids-hyperlink[disabled] {
  cursor: var(--ids-cursor-default);
  pointer-events: none;
  user-select: none;
}
.ids-hyperlink:focus {
  outline: none;
}
.ids-hyperlink.bold {
  font-weight: var(--ids-font-weight-bold);
}
.ids-hyperlink.semibold {
  font-weight: var(--ids-font-weight-semibold);
}
.ids-hyperlink.hitbox::after {
  content: "";
  display: block;
  height: var(--ids-size-40);
  top: 50%;
  left: 0;
  position: absolute;
  transform: translateY(-50%);
  width: 100%;
}
.ids-hyperlink.ids-text-10 {
  font-size: var(--ids-font-size-3xs);
  text-transform: var(--ids-font-uppercase);
}
.ids-hyperlink.ids-text-12, .ids-hyperlink.ids-text-xs {
  font-size: var(--ids-font-size-2xs);
  text-transform: var(--ids-font-uppercase);
}
.ids-hyperlink.ids-text-14, .ids-hyperlink.ids-text-sm {
  font-size: var(--ids-font-size-xs);
}
.ids-hyperlink.ids-text-16, .ids-hyperlink.ids-text, .ids-hyperlink.ids-text-base {
  font-size: var(--ids-font-size-sm);
}
.ids-hyperlink.ids-text-20 {
  font-size: var(--ids-font-size-md);
}
.ids-hyperlink.ids-text-24, .ids-hyperlink.ids-text-lg {
  font-size: var(--ids-font-size-xl);
}
.ids-hyperlink.ids-text-28 {
  font-size: var(--ids-font-size-xl);
}
.ids-hyperlink.ids-text-32, .ids-hyperlink.ids-text-xl {
  font-size: var(--ids-font-size-2xl);
}
.ids-hyperlink.ids-text-40 {
  font-size: var(--ids-font-size-3xl);
}
.ids-hyperlink.ids-text-48 {
  font-size: var(--ids-font-size-4xl);
}
.ids-hyperlink.ids-text-60 {
  font-size: var(--ids-font-size-5xl);
}
.ids-hyperlink.ids-text-72 {
  font-size: var(--ids-font-size-6xl);
  margin-bottom: 0;
}
.ids-hyperlink:not(.ids-hyperlink-color-unset) {
  color: var(--ids-hyperlink-color-text-default);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).show-visited-color:visited {
  color: var(--ids-hyperlink-color-text-visited);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset):focus {
  border: 1px solid var(--ids-hyperlink-color-text-default);
  box-shadow: var(--ids-shadow-focus);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset):hover:not([disabled]):not(.ids-text-decoration-hover):not(.disabled):not(.color-variant-breadcrumb), .ids-hyperlink:not(.ids-hyperlink-color-unset):active:not([disabled]):not(.ids-text-decoration-hover):not(.disabled):not(.color-variant-breadcrumb) {
  color: var(--ids-hyperlink-color-text-hover);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).disabled, .ids-hyperlink:not(.ids-hyperlink-color-unset)[disabled] {
  color: var(--ids-hyperlink-color-text-disabled);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).hide-focus:focus {
  border-color: var(--ids-color-transparent);
  box-shadow: none;
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb {
  color: var(--ids-breadcrumb-color-text-default);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb.disabled, .ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb[disabled] {
  color: var(--ids-breadcrumb-color-text-disabled);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb.semibold {
  color: var(--ids-breadcrumb-color-text-selected);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb.semibold:hover {
  color: var(--ids-breadcrumb-color-text-selected);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb:hover {
  color: var(--ids-breadcrumb-color-text-hover);
  text-decoration: none;
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-alternate {
  color: var(--ids-breadcrumb-color-text-emphasis);
}
.ids-hyperlink.ids-hyperlink-color-unset:focus {
  --ids-box-shadowed-color-border: 1px solid var(--ids-hyperlink-color-text-default);
  --ids-box-shadow: var(--ids-box-shadow-focus);
}

.ids-text-decoration-none {
  text-decoration: none;
}
.ids-text-decoration-none:hover {
  text-decoration: none;
}

.ids-text-decoration-hover {
  text-decoration: none;
}
.ids-text-decoration-hover:hover {
  text-decoration: underline;
}

:host(:not([allow-empty-href=false])) .ids-hyperlink:not(.ids-text-decoration-none):not(.color-variant-breadcrumb):not(.ids-text-decoration-hover) {
  text-decoration: underline;
}

::slotted(ids-box:not([height])) {
  --ids-box-height: var(--ids-hyperlink-box-height);
}

::slotted(ids-box:not([width])) {
  --ids-box-width: var(--ids-hyperlink-box-width);
}

.ids-hyperlink.colspan ::slotted(ids-box:not([width])) {
  --ids-box-width: var(--ids-hyperlink-box-width-double);
}

::slotted(ids-box) {
  text-align: center;
  --ids-icon-height-default: var(--ids-space-2xl);
  --ids-icon-width-default: var(--ids-space-2xl);
  --ids-icon-color-default: var(--ids-hyperlink-box-icon-color-text-default);
  --ids-box-padding: var(--ids-space-xs);
}

::slotted(ids-box:hover) {
  --ids-box-shadowed-color-border: 1px solid var(--ids-hyperlink-box-color-border-default);
}

::slotted(ids-icon) {
  --ids-icon-color-default: var(--ids-hyperlink-color-text-default);
  display: inline;
  margin-inline-end: var(--ids-space-xs);
  top: var(--ids-space-2xs);
}

:host(.disabled) .ids-hyperlink,
:host([disabled]) .ids-hyperlink,
:host-context(.disabled) .ids-hyperlink,
:host-context([disabled]) .ids-hyperlink {
  color: var(--ids-hyperlink-color-text-disabled);
  cursor: var(--ids-cursor-default);
  pointer-events: none;
  user-select: none;
}`;var O=x(f(u(b(p)))),o,y,r=class extends O{constructor(){super();l(this,o);n(this,"colorVariants",["breadcrumb","alternate"]);n(this,"fontSizes",[{10:"10px"},{12:"12px"},{14:"14px"},{16:"16px"},{20:"20px"},{24:"24px"},{28:"28px"},{32:"32px"},{40:"40px"},{48:"48px"},{60:"60px"},{72:"72px"}])}connectedCallback(){super.connectedCallback(),this.getAttribute("role")||this.setAttribute("role","link"),a(this,o,y).call(this)}static get attributes(){return[...super.attributes,t.ALLOW_EMPTY_HREF,t.COLOR,t.COL_SPAN,t.DISABLED,t.FONT_SIZE,t.FONT_WEIGHT,t.HREF,t.TARGET,t.TEXT_DECORATION,t.SHOW_VISITED_COLOR]}template(){let i=this.disabled?" disabled":"",e=this.href?` href="${this.href}"`:"",k=this.disabled?' tabindex="-1"':"",m=this.target?` target="${this.target}"`:"",g=this.color==="unset"?" ids-hyperlink-color-unset":"",A=this.fontSize?` ids-text-${this.fontSize}`:"",E=this.fontWeight?` ${this.fontWeight}`:"",T=this.textDecoration?` ids-text-decoration-${this.textDecoration}"`:"";return`<a
      class="ids-hyperlink${g}${A}${E}${T}"
      ${i}
      ${e}
      ${k}
      ${m}
      part="link">
        <slot></slot>
    </a>`}set href(i){if(i){this.setAttribute(t.HREF,i),this.container?.setAttribute(t.HREF,i);return}this.removeAttribute(t.HREF),this.container?.removeAttribute(t.HREF)}get href(){return this.getAttribute(t.HREF)}set target(i){if(i){this.setAttribute(t.TARGET,i),this.container?.setAttribute(t.TARGET,i);return}this.removeAttribute(t.TARGET),this.container?.removeAttribute(t.TARGET)}get target(){return this.getAttribute(t.TARGET)}set textDecoration(i){if(this.container?.classList.remove("ids-text-decoration-none","ids-text-decoration-hover"),i?.toLowerCase()==="none"){this.setAttribute(t.TEXT_DECORATION,i),this.container?.classList.add("ids-text-decoration-none");return}if(i?.toLowerCase()==="hover"){this.setAttribute(t.TEXT_DECORATION,i),this.container?.classList.add("ids-text-decoration-hover");return}this.removeAttribute(t.TEXT_DECORATION)}get textDecoration(){return this.getAttribute(t.TEXT_DECORATION)}set showVisitedColor(i){if(s(i)){this.setAttribute(t.SHOW_VISITED_COLOR,""),this.container?.classList.add("show-visited-color"),this.container?.setAttribute("tabindex","-1");return}this.removeAttribute(t.SHOW_VISITED_COLOR),this.container?.classList.add("show-visited-color")}get showVisitedColor(){return s(this.getAttribute(t.SHOW_VISITED_COLOR))||!1}set disabled(i){if(s(i)){this.setAttribute(t.DISABLED,""),this.container?.setAttribute(t.DISABLED,""),this.container?.setAttribute("tabindex","-1");return}this.removeAttribute(t.DISABLED),this.container?.removeAttribute(t.DISABLED),this.container?.removeAttribute("tabindex")}get disabled(){return this.hasAttribute(t.DISABLED)}set color(i){i==="unset"?(this.setAttribute(t.COLOR,i),this.container?.classList.add("ids-hyperlink-color-unset")):(this.removeAttribute(t.COLOR),this.container?.classList.remove("ids-hyperlink-color-unset"))}get color(){return this.getAttribute(t.COLOR)}set fontSize(i){if(this.fontSizes?.forEach(e=>{this.container?.classList.remove(`ids-text-${Object.keys(e)}`)}),i){this.setAttribute(t.FONT_SIZE,i),this.container?.classList.add(`ids-text-${i}`);return}this.removeAttribute(t.FONT_SIZE)}get fontSize(){return this.getAttribute(t.FONT_SIZE)}set fontWeight(i){if(this.container?.classList.remove("bold","lighter","semibold"),i==="semibold"||i==="bold"||i==="lighter"){this.setAttribute(t.FONT_WEIGHT,i),this.container?.classList.add(i);return}this.removeAttribute(t.FONT_WEIGHT)}get fontWeight(){return this.getAttribute(t.FONT_WEIGHT)}set allowEmptyHref(i){let e=s(i);this.setAttribute(t.ALLOW_EMPTY_HREF,String(e))}get allowEmptyHref(){let i=this.getAttribute(t.ALLOW_EMPTY_HREF);return i?s(i):!0}set colSpan(i){i!==null?(this.setAttribute(t.COL_SPAN,i),this.container?.classList.add("colspan")):(this.removeAttribute(t.COL_SPAN),this.container?.classList.remove("colspan"))}get colSpan(){return this.getAttribute(t.COL_SPAN)}};o=new WeakSet,y=function(){this.onEvent("click.ids-hyperlink",this,i=>{this.disabled&&(i.preventDefault(),i.stopImmediatePropagation())})},r=d([h("ids-hyperlink"),c(v)],r);export{r as a};
